<template>
  <v-row>
    <v-col 
      cols="4"
      v-for="auditorium in auditoriums"
      :key="auditorium.id">
      
      <v-card
        :loading="loading"
        class="mx-auto my-12"
        max-width="374"
      >
        <v-img
          height="250"
          :src="auditorium.url_miniature"
        ></v-img>

        <v-card-title>{{ auditorium.name }}</v-card-title>

      </v-card>
    </v-col>

    <v-col cols="12" class="pt-8 d-sm-flex">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'auditoriumsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-spacer />
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showAllAuditoriumEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      activeChat: true,
      auditoriums:[],
      name:null,

      data:[],

      entrepreneurship:[],

      banner:null,
      url_banner:null,

      miniature:null,
      url_miniature:null,
    }),

    methods:{
      async getAuditorium(){
        await axios.get('admin/editions/'+this.edition_id+'/auditoriums/show/all' ).then(response =>{
          this.data = response.data.data
          this.auditoriums = response.data.data.auditoriums

          this.auditoriums.forEach(element => {
            element.url_miniature = APP_URL + element.miniature
          });



          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },
    },

    created(){
       this.edition_id = this.$route.params.edition_id;
       this.auditorium_id = this.$route.params.auditorium_id;
       this.getAuditorium()
    },
  }
</script>
<style>
.images {
  position: fixed;
}
</style>
<style scoped>
.image-banner{
	position: relative;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}

.contenedor-imagen {
  position: relative;
  display: inline-block; /* O cualquier otro valor que se ajuste a tu diseño */
}


.image-miniature{
	position: relative;
	width: 100%;
  border-radius: 4px;
  border: 1px solid #00a1b8;
  display: block;
}

.section-chat{
  padding-top: 4px;
  position: relative;
	width: 100%;
  min-height:100%;
  border-radius: 4px;
  border: 1px solid #00a1b8;
}
</style>